module.exports = __webpack_public_path__ + "static/media/icon-star-green.da9d4cbd.svg";